import React from "react";

import { css } from "@emotion/css";
import BGImg from "../../../img/jpg/tech/hero-bg.jpg";
import N06Img from "../../../img/svg/tech/06.svg";
import N05Img from "../../../img/svg/tech/05.svg";
import N99Img from "../../../img/svg/tech/99.svg";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useI18n } from "../../../i18n";

const Hero = () => {
  const { t } = useI18n();
  return (
  <div className={style.container}>
    <span className="overlay"></span>
    <div className="wrapper">
      <h2 className="first"><span className="sr-only">{t("tech_hero_ai")}</span></h2>
      <h1>{t("tech_hero_ai")}</h1>
      <h2 className="last">{t("tech_hero_service")}</h2>
      <div className="content">
      <svg xmlns="http://www.w3.org/2000/svg" width="188" height="8" viewBox="0 0 188 8" fill="none">
<path d="M4 4H184" stroke="#EADAFF" stroke-opacity="0.3" stroke-width="8" stroke-linecap="round"/>
</svg>
        <p>
          {t("tech_hero_desc")}
        </p>
        <div className="rows">
          <span>
            <img src={N06Img} className="img-06" alt="06" />
            <h3 style={{ color: "#6643FF" }}>{t("tech_hero_models")}</h3>
          </span>
          <span>
            <img src={N05Img} className="img-05" alt="05" />
            <h3 style={{ color: "#A85CFF" }}>{t("tech_hero_scan")}</h3>
          </span>
          <span>
            <img src={N99Img} className="img-99" alt="99" />
            <h3 style={{ color: "#FE6AFD" }}>{t("tech_hero_accuracy")}</h3>
          </span>
        </div>
      </div>
    </div>
  </div>
  );
};

const style = {
  container: css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flexWrap: "nowrap",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "auto",
    backgroundColor: "#fff",
    height: 1080,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    backgroundImage: `url(${BGImg})`,
    position: "relative",
    marginBottom: "440px",

    ".overlay": {
      background: "linear-gradient(#ffffff00, #ffffff)",
      height: 345,
      flexShrink: 0,
      width: "100%",
      position: "absolute",
      bottom: 0,
      zIndex: 0,
    },
    ".wrapper": {
      width: 1314,
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      zIndex: 1,
      marginBottom: "-280px",

      h1: {
        color: "#6643FF",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 76,
        fontStyle: "normal",
        fontWeight: 800,
        lineHeight: "normal",
        letterSpacing: 1.52,
        textTransform: "uppercase",
        maxWidth: 1080,
        width: "100%",
      },
      h2: {
        color: "#6643FF",
        fontFamily: "Syne",
        fontSize: 38,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "normal",
        letterSpacing: 0.76,
        maxWidth: 1080,
        width: "100%",

        "&.first": {
          textAlign: "left",
          marginBottom: 10,
        },
        "&.last": {
          textAlign: "right",
          marginTop: 10,
        },
      },
      ".content ": {
        marginTop: 50,
        display: "flex",
        padding: "24px 22px 22px 22px",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        flexShrink: 0,
        borderRadius: 100,
        border: "1.5px solid rgba(102, 67, 255, 0.30)",
        background:
          "linear-gradient(0deg, rgba(255, 255, 255, 0.00) 34.05%, #FFF 100%), #E3DDFE",
        maxWidth: 1314,
        width: "100%",
      },
      stroke: {
        width: 180,
        height: 0,
        flexShrink: 0,
        strokeWidth: 8,
        stroke: 'rgba(234, 218, 255, 0.30)',
      },
      p: {
        color: "#A85CFF",
        textAlign: "center",
        fontFamily: "Inter",
        fontSize: 20,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "30px",
        maxWidth: 900,
        width: "100%",
        marginBottom: 60,
        marginTop: 50,
      },
      ".rows": {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        gap: 15,
        width: "100%",

        span: {
          display: "flex",
          maxWidth: 412.667,
          width: "100%",
          height: 232,
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 40,
          borderRadius: 80,
          position: "relative",
          overflow: "hidden",
          background:
            "linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%)",

          h3: {
            color: "#6643FF",
            fontFamily: "Inter",
            fontSize: 20,
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            letterSpacing: 0.4,
            maxWidth: 140,
            paddingRight: 42,
            marginLeft: "auto",
          },
          img: {
            width: "auto",
            height: "auto",
            position: "absolute",
            bottom: 0,
            left: 0,

            "&.img-06": {
              bottom: 40,
            },
            "&.img-05": {
              bottom: -5,
            },
          },
        },
      },
    },
    [desktop]: {
      height: 738,
      marginBottom: "360px",

      ".overlay": {
        height: 345,
      },
      ".wrapper": {
        width: 904,
        marginBottom: "-300px",
        marginLeft: 30,
        marginRight: 30,

        h1: {
          fontSize: 46,
          maxWidth: 660,
        },
        h2: {
          fontSize: 24,
          letterSpacing: "0.48px",
          maxWidth: 660,

          "&.first": {
            marginBottom: 5,
          },
          "&.last": {
            marginTop: 5,
          },
        },
        ".content ": {
          marginTop: 50,
          maxWidth: 904,
          width: "100%",
          padding: "24px 22px 22px 22px",
          marginLeft: 30,
          marginRight: 30,
        },
        p: {
          fontSize: 14,
          lineHeight: "20px",
          maxWidth: 960,
          marginBottom: 60,
          marginTop: 20,
        },
        ".rows": {
          gap: 15,

          span: {
            maxWidth: 312,
            height: 200,
            gap: 40,
            borderRadius: 80,
            h3: {
              fontSize: 20,
              paddingRight: 16,
            },
            img: {
              width: "40%",
              height: "auto",
              "&.img-05": {
                bottom: 40,
              },
              "&.img-99": {
                bottom: 40,
              },
            },
          },
        },
      },
    },
    [laptop]: {
      ".content ": {
        marginTop: 50,
        maxWidth: 904,
        width: "100%",
        padding: "24px 22px 22px 22px",
        marginLeft: 30,
        marginRight: 30,
      },
      ".wrapper": {
        maxWidth: 703,

        p: {
          fontSize: 16,
          lineHeight: "24px",
          maxWidth: 605,
          marginBottom: 60,
          marginTop: 20,
        },
        ".rows": {
          gap: 15,

          span: {
            maxWidth: 211,
            height: 200,
            h3: {
              fontSize: 14,
              paddingRight: 10,
              marginLeft: "auto",
              width: "85px",
            },
            img: {
              width: "50%",
              height: "auto",
              "&.img-05": {
                bottom: 40,
              },
              "&.img-99": {
                bottom: 40,
              },
            },
          },
        },
      },
    },
    [tablet]: {
      height: '100%',
      paddingTop: "500px",
      backgroundSize: '1000px',

      ".overlay": {
        top: 300,
        height: 245,
      },
      ".wrapper": {
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        width: '100%',
        alignItems: 'stretch',

        h1: {
          fontSize: 24,
          maxWidth: 355,
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingLeft: 20,
          paddingRight: 20,
          width: 'auto'
        },
        h2: {
          fontSize: 18,
          letterSpacing: "0.48px",
          maxWidth: 355,
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingLeft: 20,
          paddingRight: 20,
          width: 'auto',

          "&.first": {
            marginBottom: 5,
          },
          "&.last": {
            marginTop: 5,
          },
        },
        ".content ": {
          marginTop: 20,
          maxWidth: 904,
          width: "auto",
          padding: "24px 22px 22px 22px",
          marginLeft: 0,
          marginRight: 0,
          borderTop: 0,
        },
        p: {
          fontSize: 14,
          lineHeight: "20px",
          maxWidth: 337,
          marginBottom: 60,
          marginTop: 20,
        },
        ".rows": {
          gap: 15,
          flexDirection: 'column',

          span: {
            maxWidth: 337,
            height: 210,
            gap: 40,
            borderRadius: 80,
            h3: {
              fontSize: 18,
              paddingRight: 24,
              width: 120
            },
            img: {
              width: "50%",
              height: "auto",
              "&.img-05": {
                bottom: 40,
              },
              "&.img-99": {
                bottom: 40,
              },
            },
          },
        },
      },
    },
  }),
};

export default Hero;
